import { FC, ReactNode } from 'react'
import { Icon, IconType } from '@lmc/ui-kit'
import styled from 'styled-components'
import { Logo } from './Logo'
import { LogoutButton } from './LogoutButton'

type Props = {
  children: ReactNode
}

export const OnboardingLayout: FC<Props> = ({ children }) => {
  return (
    <>
      <Icon
        customIcon={IconType.CleanLargeLogoIcon}
        style={{
          height: '100vh',
          width: 585,
          position: 'fixed',
          right: 0,
          top: '-20px',
          overflow: 'hidden'
        }}
      />
      <Wrapper>
        <TopWrapper>
          <Logo />
          <LogoutButton />
        </TopWrapper>
        <CenterWrapper>{children}</CenterWrapper>
      </Wrapper>
    </>
  )
}

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.color.neutral.color11};
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 100px 160px;
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    padding: 10px;
  }
`

const TopWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

const CenterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: auto;
  margin-top: auto;
  z-index: 1;
`
